import { api } from 'services/api';

import { sortAlphabetical } from 'utils/utils';
import {
	calculatePagination, invalidPage, getStatsFromCache, orderParams,
} from '../../base/common/utils';

export class SearchService {
	constructor() {
		this.Api = api;
		this.limit = 500; // The size of API responses, perPage is for the display
		this.paginationOptions = [500, 100, 50];

		this.page = null; // Current page according to backend (perPage 500)
		this.indexStart = null;
		this.indexEnd = null;

		this.merchants = [];
		this.trendsByMerch = {};
		this.merchSlugIds = [
			{slug: 'bedbathandbeyond', merch_id: 1100},
			{slug: 'buybuybaby', merch_id: 1179},
			{slug: 'dermstore', merch_id: 1005},
			{slug: 'dvf', merch_id: 1138},
			{slug: 'forward', merch_id: 1043},
			{slug: 'kosas', merch_id: 1218},
			{slug: 'lovelyskin', merch_id: 1215},
			{slug: 'macys', merch_id: 1023},
			{slug: 'revolve', merch_id: 1042},
			{slug: 'saks', merch_id: 1002},
			{slug: 'ultabeauty', merch_id: 1158},
			{slug: 'versedskin', merch_id: 1229},
			{slug: 'violetgrey', merch_id: 1004},
			{slug: 'yoox', merch_id: 1008},
		];
	}

	getMerchants() {
		return this.Api.get('/api/v0/merchants/').then((resp) => {
			this.merchants = [];
			const merchSlugs = this.merchSlugIds.map((slugId) => slugId.slug);
			resp.data.data.forEach((merchant) => {
				if (merchSlugs.includes(merchant.slug) && merchant.show_in_dashboard) {
					merchant.label = merchant.full_name;
					this.merchants.push(merchant);
				}
			});

			return sortAlphabetical(this.merchants, 'full_name');
		}); // TODO: Error response
	}

	getSearchTrends(pubId, params, pageNum, perPage, resetPages=false) {
		if (!this.trendsByMerch[params.merch_ids]) {
			this.trendsByMerch[params.merch_ids] = {
				pages: {},
				last_query_params: {},
			};
		}

		if (resetPages) {
			this.trendsByMerch[params.merch_ids].pages = {};
		}

		const stats = this.trendsByMerch[params.merch_ids];
		const totalTerms = stats ? stats.total_items || 0 : 0;
		[this.page, this.indexStart, this.indexEnd] = calculatePagination(
			pageNum, perPage, this.limit
		);

		if (invalidPage(this.page, totalTerms, this.limit)) {
			return Promise.resolve('The page requested does not exist');
		}

		params.page = this.page;
		params.per_page = this.limit;
		if (stats.pages[this.page] && this.isSameQuery(params, stats.last_query_params)) {
			return getStatsFromCache(stats, this.page, this.indexStart, this.indexEnd);
		}

		return this.querySearchTrends(pubId, params);
	}

	querySearchTrends(pubId, params) {
		if (params.search_term === '') params.search_term = null;

		const paramKeys = [
			'date_from', 'date_to', 'page', 'per_page', 'merch_ids', 'search_term',
			'order_by', 'direction',
		];
		params = orderParams(params, paramKeys);

		return this.Api.get(`/api/v0/publishers/${pubId}/searches/`, params).then(
			(resp) => this.onSearchTrendsLoaded(resp, params)
			// TODO: add error modal () => onError(),
		);
	}

	onSearchTrendsLoaded(resp, params) {
		const merchIds = params.merch_ids;
		const data = resp.data.data.length ? resp.data.data[0] : [];
		this.trendsByMerch[merchIds].pages[this.page] = data.stats;

		Object.assign(this.trendsByMerch[merchIds], {
			total_items: data.page_info.total_items,
			total_searches: data.page_info.total_searches,
			last_query_params: Object.assign({}, params),
		});

		return getStatsFromCache(
			this.trendsByMerch[merchIds], this.page, this.indexStart, this.indexEnd
		);
	}

	/* Helper functions */
	isSameQuery(params, previousParams) {
		return params.search_term === previousParams.search_term &&
			params.order_by === previousParams.order_by &&
			params.direction === previousParams.direction;
	}
}

export default new SearchService();
